import { PostSort, type PostSummaryDto } from '@gr/core/content/posts/dto';

export enum PostDateKind {
  Created = 'created',
  Updated = 'updated',
  Published = 'published',
  Planned = 'planned',
}

export interface PostDate {
  kind: PostDateKind;
  iso: string;
  /** По этой дате отсортирован список — выделяется. */
  sortKey: boolean;
}

/**
 * POST-UC-6, POST-UC-6.CC-1: даты в строке списка. Создание — всегда; изменение — если отличается от
 * создания или список отсортирован по нему; выход — первый, а пока не выходил — ближайший по плану.
 */
export function postDates(post: Pick<PostSummaryDto, 'createdAt' | 'updatedAt' | 'publishedAt' | 'plannedAt'>, sortedBy: PostSort, sameMomentSeconds: number): PostDate[] {
  const dates: PostDate[] = [{ kind: PostDateKind.Created, iso: post.createdAt, sortKey: sortedBy === PostSort.Created }];
  // Правки вскоре после создания (ui.posts.dates.sameMomentSeconds) — то же создание.
  const edited = Date.parse(post.updatedAt) - Date.parse(post.createdAt) >= sameMomentSeconds * 1000;
  if (edited || sortedBy === PostSort.Updated) dates.push({ kind: PostDateKind.Updated, iso: post.updatedAt, sortKey: sortedBy === PostSort.Updated });
  if (post.publishedAt) dates.push({ kind: PostDateKind.Published, iso: post.publishedAt, sortKey: false });
  else if (post.plannedAt) dates.push({ kind: PostDateKind.Planned, iso: post.plannedAt, sortKey: false });
  return dates;
}
